export const RoyaltyType = {
  EXCLUSIVE: "EXCLUSIVE",
  NON_EXCLUSIVE: "NON_EXCLUSIVE"
}